import { IDemo, SessionIds } from 'types'
import track from 'assets/captions/managed-venues.en.vtt'
import { getSharedAsset } from '../utils'

const video = getSharedAsset('managed-venues.mp4', 'sessions', 'videos')
const poster = getSharedAsset('managed-venues.png', 'sessions', 'posters')
const monolith = getSharedAsset('managed-venues.png', 'sessions', 'monoliths')
const nextDemoThumbnail = getSharedAsset('video-security-and-analytics.png', 'sessions', 'thumbnails')

export const managedVenues: IDemo = {
  id: SessionIds.managedVenues,
  video,
  monolith,
  poster,
  tracks: [
    {
      kind: 'captions',
      src: track,
      srcLang: 'en',
      label: 'EN',
      default: false
    }
  ],
  end: {
    header: 'Managed Venues',
    body: `Discover how ultra-fast download speeds with ultra-low latency brought by Verizon 5G UWB network in conjunction with our private 5G MEC will be able to enhance public safety and enable transformative use-cases in venue security. `,
    nextDemoText: 'Video Security & Analytics',
    nextDemoId: SessionIds.videoSecurity,
    nextDemoThumbnail,
    previousDemoId: SessionIds.connectedHealth
  }
}
